import axios from 'axios';
import { createContext, useState } from 'react';
const baseUrl = process.env.REACT_APP_BASE_URL || '/';

export const GlobleContext = createContext()

const ContextProvider = ({ children }) => {
    const [contactuseData, setContactUsData] = useState([]);
    const [profileData, setProfileData] = useState([]);
    const [productCategoryData, setProductCategoryData] = useState([]);
    const [aboutUsData, setAboutUsData] = useState([]);

    const getContactUsData = async () => {
        const response = await axios.post(`${baseUrl}ContactUs/GetContactUs`, {
            PaginationID: "-1", OfficeType: "Main Office"
        });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                // console.log("ssdsdsdsdddddddd", response)
                setContactUsData(response.data.data[0]);
            }
        }
    };

    const getProfileData = async () => {
        const response = await axios.post(`${baseUrl}Profile/GetProfile`, { PaginationID: "-1" });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setProfileData(response.data.data[0]);
            }
        }
    };

    const getProductCategoryData = async () => {
        const response = await axios.get(`${baseUrl}ProductCategory/GetCategoryItems`);
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setProductCategoryData(response.data.data);
            }
        }
    };

    const getAboutUsData = async (filterType) => {
        const response = await axios.post(`${baseUrl}AboutUs/GetAboutUs`, { Type: filterType });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setAboutUsData(response.data.data);
            }
        }
    };

    return (
        <GlobleContext.Provider value={{ getContactUsData, contactuseData, getProfileData, profileData, getProductCategoryData, productCategoryData, getAboutUsData, aboutUsData }}>
            {children}
        </GlobleContext.Provider>
    )
}
export default ContextProvider
